import React, { useState, useEffect } from "react";

export default ({
  fields,
  validationErrors,
  handleChange,
  universityAttends,
  setUniversityAttends,
  tournamentsAttends,
  setTournamentsAttends,
  leaguesAttends,
  setLeaguesAttends,
}) => {
  //universityAttends
  const handleChangeForm = (index, event) => {
    const newForms = [...universityAttends];
    newForms[index].name = event.target.value;
    setUniversityAttends(newForms);
  };

  const handleAddForm = () => {
    setUniversityAttends([...universityAttends, { name: "" }]);
  };

  const handleRemoveForm = (index) => {
    const newForms = [...universityAttends];
    newForms.splice(index, 1);
    setUniversityAttends(newForms);
  };

  //tournaments
  const handleChangeTourForm = (index, event) => {
    const newForms = [...tournamentsAttends];
    newForms[index].name = event.target.value;
    setTournamentsAttends(newForms);
  };

  const handleAddTourForm = () => {
    setTournamentsAttends([...tournamentsAttends, { name: "" }]);
  };

  const handleRemoveTourForm = (index) => {
    const newForms = [...tournamentsAttends];
    newForms.splice(index, 1);
    setTournamentsAttends(newForms);
  };

  //leagues
  const handleChangeLeaguesForm = (index, event) => {
    const newForms = [...leaguesAttends];
    newForms[index].name = event.target.value;
    setLeaguesAttends(newForms);
  };

  const handleAddLeaguesForm = () => {
    setLeaguesAttends([...leaguesAttends, { name: "" }]);
  };

  const handleRemoveLeaguesForm = (index) => {
    const newForms = [...leaguesAttends];
    newForms.splice(index, 1);
    setLeaguesAttends(newForms);
  };

  return (
    <>
      <div className="row">
        <div className="form-group col-md-6">
          <label htmlFor="player_classification">Player Classification</label>
          <div className="col-md-12">
            <select
              className="form-select"
              name="player_classification"
              onChange={handleChange("player_classification")}
              value={fields.player_classification}
            >
              <option value="" selected>
                Select{" "}
              </option>
              <option
                value="junior"
                selected={
                  fields?.player_classification === "junior" ? "selected" : ""
                }
              >
                Junior{" "}
              </option>
              <option
                value="college"
                selected={
                  fields?.player_classification === "college" ? "selected" : ""
                }
              >
                College/University{" "}
              </option>
              <option
                value="professional"
                selected={
                  fields?.player_classification === "professional"
                    ? "selected"
                    : ""
                }
              >
                Professional{" "}
              </option>
              <option
                value="adult_competitive"
                selected={
                  fields?.player_classification === "adult_competitive"
                    ? "selected"
                    : ""
                }
              >
                Adult Competitive{" "}
              </option>
              <option
                value="adult_social"
                selected={
                  fields?.player_classification === "adult_social"
                    ? "selected"
                    : ""
                }
              >
                Adult Social{" "}
              </option>
            </select>
            {/* {validationErrors.player_classification && (
                            <div className="text-danger err">{validationErrors.player_classification}</div>
                        )} */}
          </div>
        </div>
      </div>
      {fields?.player_classification === "junior" && (
        <>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">Academy Name (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Academy Name"
                name="academy_name"
                onChange={handleChange("academy_name")}
                value={fields.academy_name}
              />
              {/* {validationErrors.academy_name && (
                <div className="text-danger err">{validationErrors.academy_name}</div>
              )} */}
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="name">High School (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="High School"
                name="hight_school"
                onChange={handleChange("hight_school")}
                value={fields.hight_school}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">Graduation Year (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Graduation Year"
                name="graduation_year"
                onChange={handleChange("graduation_year")}
                value={fields.graduation_year}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <div className="row">
                <div className="col-md-8">
                  <label htmlFor="name">
                    Top 5 Colleges/Universities to attend and play tennis
                    (Optional)
                  </label>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-gradient-primary btn-sm"
                    onClick={handleAddForm}
                  >
                    {" "}
                    + Add
                  </button>
                </div>
              </div>
              <br />
              <div>
                {universityAttends.map((form, index) => (
                  <div className="row align-items-center">
                    <div className="col-md-9 my-2" key={index}>
                      <input
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={form.name}
                        onChange={(event) => handleChangeForm(index, event)}
                      />
                    </div>
                    {index > 0 && (
                      <div className="col-md-3 my-2">
                        <button
                          type="button"
                          className="bg-transparent border-0 p-0"
                          onClick={() => handleRemoveForm(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                          >
                            <path
                              d="M10.7876 28.3333C10.1359 28.3333 9.59192 28.1152 9.15559 27.6788C8.71831 27.2415 8.49967 26.6971 8.49967 26.0454V8.49999H7.08301V7.08333H12.7497V5.99249H21.2497V7.08333H26.9163V8.49999H25.4997V26.0454C25.4997 26.6971 25.2815 27.2411 24.8452 27.6774C24.4079 28.1147 23.8634 28.3333 23.2118 28.3333H10.7876ZM13.8943 24.0833H15.311V11.3333H13.8943V24.0833ZM18.6883 24.0833H20.105V11.3333H18.6883V24.0833Z"
                              fill="#C51212"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      {fields?.player_classification === "college" && (
        <>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">College/University (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="College/University"
                name="college"
                onChange={handleChange("college")}
                value={fields.college}
              />
              {/* {validationErrors.college && (
                <div className="text-danger err">
                  {validationErrors.college}
                </div>
              )} */}
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="name">Graduation Year (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Graduation Year"
                name="graduation_year"
                onChange={handleChange("graduation_year")}
                value={fields.graduation_year}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">Major (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Major"
                name="major"
                onChange={handleChange("major")}
                value={fields.major}
              />
            </div>
          </div>
        </>
      )}
      {fields?.player_classification === "professional" && (
        <>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">Training Facility (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder="Training Facility"
                name="training_facility"
                onChange={handleChange("training_facility")}
                value={fields.training_facility}
              />
              {/* {validationErrors.training_facility && (
                <div className="text-danger err">
                  {validationErrors.training_facility}
                </div>
              )} */}
            </div>
          </div>
        </>
      )}
      {fields?.player_classification === "adult_competitive" && (
        <>
          <div className="row">
            <div className="form-group col-md-6">
              <div className="row">
                <div className="col-md-8">
                  <label htmlFor="name">
                    What type of tournaments do you play? (Optional)
                  </label>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-gradient-primary btn-sm"
                    onClick={handleAddTourForm}
                  >
                    {" "}
                    + Add
                  </button>
                </div>
              </div>
              <br />
              <div className="row">
                {tournamentsAttends.map((tour, index) => (
                  <div className="row align-items-center">
                    <div className="col-md-9 my-2" key={index}>
                      <input
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={tour.name}
                        onChange={(event) => handleChangeTourForm(index, event)}
                      />
                    </div>
                    {index > 0 && (
                      <div className="col-md-3 my-2">
                        <button
                          type="button"
                          className="bg-transparent border-0 p-0"
                          onClick={() => handleRemoveTourForm(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                          >
                            <path
                              d="M10.7876 28.3333C10.1359 28.3333 9.59192 28.1152 9.15559 27.6788C8.71831 27.2415 8.49967 26.6971 8.49967 26.0454V8.49999H7.08301V7.08333H12.7497V5.99249H21.2497V7.08333H26.9163V8.49999H25.4997V26.0454C25.4997 26.6971 25.2815 27.2411 24.8452 27.6774C24.4079 28.1147 23.8634 28.3333 23.2118 28.3333H10.7876ZM13.8943 24.0833H15.311V11.3333H13.8943V24.0833ZM18.6883 24.0833H20.105V11.3333H18.6883V24.0833Z"
                              fill="#C51212"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="name">What is your profession? (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder=""
                name="profession"
                onChange={handleChange("profession")}
                value={fields.profession}
              />
            </div>
          </div>
        </>
      )}
      {fields?.player_classification === "adult_social" && (
        <>
          <div className="row">
            <div className="form-group col-md-6">
              <div className="row">
                <div className="col-md-8">
                  <label htmlFor="name">
                    What tennis leagues do you play? (Optional)
                  </label>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-gradient-primary btn-sm"
                    onClick={handleAddLeaguesForm}
                  >
                    {" "}
                    + Add
                  </button>
                </div>
              </div>
              <br />
              <div className="row">
                {leaguesAttends.map((leagues, index) => (
                  <div className="row align-items-center">
                    <div className="col-md-9 my-2" key={index}>
                      <input
                        type="text"
                        placeholder=""
                        className="form-control"
                        value={leagues.name}
                        onChange={(event) =>
                          handleChangeLeaguesForm(index, event)
                        }
                      />
                    </div>
                    {index > 0 && (
                      <div className="col-md-3 my-2">
                        <button
                          type="button"
                          className="bg-transparent border-0 p-0"
                          onClick={() => handleRemoveLeaguesForm(index)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                          >
                            <path
                              d="M10.7876 28.3333C10.1359 28.3333 9.59192 28.1152 9.15559 27.6788C8.71831 27.2415 8.49967 26.6971 8.49967 26.0454V8.49999H7.08301V7.08333H12.7497V5.99249H21.2497V7.08333H26.9163V8.49999H25.4997V26.0454C25.4997 26.6971 25.2815 27.2411 24.8452 27.6774C24.4079 28.1147 23.8634 28.3333 23.2118 28.3333H10.7876ZM13.8943 24.0833H15.311V11.3333H13.8943V24.0833ZM18.6883 24.0833H20.105V11.3333H18.6883V24.0833Z"
                              fill="#C51212"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="name">What is your profession? (Optional)</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputName1"
                placeholder=""
                name="profession"
                onChange={handleChange("profession")}
                value={fields.profession}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="name">What is your NTRP self ranking?</label>
              <select
                className="form-select"
                name="self_ranking"
                onChange={handleChange("self_ranking")}
                value={fields.self_ranking}
              >
                <option value="" selected disabled>
                  Select{" "}
                </option>
                <option
                  value="NTRP 2.5"
                  selected={
                    fields?.self_ranking === "NTRP 2.5" ? "selected" : ""
                  }
                >
                  NTRP 2.5
                </option>
                <option
                  value="NTRP 3.0"
                  selected={
                    fields?.self_ranking === "NTRP 3.0" ? "selected" : ""
                  }
                >
                  NTRP 3.0
                </option>
                <option
                  value="NTRP 4.0"
                  selected={
                    fields?.self_ranking === "NTRP 4.0" ? "selected" : ""
                  }
                >
                  NTRP 4.0{" "}
                </option>
                <option
                  value="NTRP 4.5"
                  selected={
                    fields?.self_ranking === "NTRP 4.5" ? "selected" : ""
                  }
                >
                  NTRP 4.5{" "}
                </option>
                <option
                  value="NTRP 5.0"
                  selected={
                    fields?.self_ranking === "NTRP 5.0" ? "selected" : ""
                  }
                >
                  NTRP 5.0{" "}
                </option>
              </select>
            </div>
          </div>
        </>
      )}
    </>
  );
};
